import { createFileRoute, redirect } from '@tanstack/react-router'

// Unpublished. The markdown checklists here were generic enough that they
// undercut the paid session; OpenAgents Control is the free artifact now.
// Content files are kept in src/content/ so any of it can be rewritten and
// brought back.
export const Route = createFileRoute('/resources')({
  beforeLoad: () => {
    throw redirect({ to: '/', statusCode: 301 })
  },
})
